import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { FilmPreviewProps } from "./FilmPreview";
const FilmPreview = lazy(() => import("./FilmPreview").then(module => ({ default: module.FilmPreview })));

export function mountFilmPreview(slot: HTMLElement, props: FilmPreviewProps) {
  setStudioView("film-preview", "film-preview", <FilmPreview key={props.model.projectId} {...props} />);
}
